import { render, staticRenderFns } from "./LetsGetAcquaintedForm.vue?vue&type=template&id=2d0db5fd&scoped=true"
import script from "./LetsGetAcquaintedForm.vue?vue&type=script&lang=js"
export * from "./LetsGetAcquaintedForm.vue?vue&type=script&lang=js"
import style0 from "./LetsGetAcquaintedForm.vue?vue&type=style&index=0&id=2d0db5fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0db5fd",
  null
  
)

export default component.exports